import React, { useEffect, useState } from 'react';
import { adminPagosPorRevisar, adminRevisarPago, urlComprobante, datosCobro, adminGuardarDatosCobro, planPorClave, fmtCobro, montoUsd } from '../services/membresiaService';
import { useToast } from '../context/ToastContext';

const fecha = (f) => new Date(f).toLocaleString('es-HN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
const CUENTA_VACIA = { banco: '', tipo: '', numero: '', titular: '' };

// Admin Kontrol: pagos por transferencia/PayPal que esperan revisión (sql/128)
// y los datos de cobro que ven las clientas al pagar.
export default function AdminPagosManuales({ negocios, onCambio }) {
  const { mostrarToast } = useToast();
  const [pagos, setPagos] = useState([]);
  const [rechazando, setRechazando] = useState(null); // { id, motivo }
  const [ocupado, setOcupado] = useState(null);
  const [cobro, setCobro] = useState(null);
  const [editandoCobro, setEditandoCobro] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const cargar = () => adminPagosPorRevisar().then(setPagos).catch(() => {});
  useEffect(() => { cargar(); datosCobro().then(setCobro).catch(() => setCobro({ cuentas: [] })); }, []);

  const verComprobante = async (ruta) => {
    const ventana = window.open('', '_blank'); // abrir antes del await (bloqueo de ventanas en celular)
    try { const url = await urlComprobante(ruta); if (ventana) ventana.location.href = url; else window.location.href = url; }
    catch { if (ventana) ventana.close(); mostrarToast('No se pudo abrir el comprobante.', 'error'); }
  };

  const revisar = async (pago, aprobar, motivo) => {
    setOcupado(pago.id);
    try {
      await adminRevisarPago(pago.id, aprobar, motivo);
      mostrarToast(aprobar ? 'Pago aprobado: plan activado ✅' : 'Pago rechazado. La clienta lo ve en Mi plan.', 'exito', 6000);
      setRechazando(null);
      cargar();
      onCambio?.(pago.negocio_id);
    } catch (e) { mostrarToast(e.message, 'error', 7000); }
    finally { setOcupado(null); }
  };

  const guardarCobro = async () => {
    setGuardando(true);
    try {
      const cuentas = (cobro.cuentas || []).map((c) => ({ banco: c.banco.trim(), tipo: c.tipo.trim(), numero: c.numero.trim(), titular: c.titular.trim() }))
        .filter((c) => c.banco || c.numero);
      await adminGuardarDatosCobro({ cuentas, paypal_usuario: (cobro.paypal_usuario || '').trim(), instrucciones: cobro.instrucciones });
      setCobro(await datosCobro());
      setEditandoCobro(false);
      mostrarToast('Datos de cobro guardados ✅', 'exito');
    } catch (e) { mostrarToast(e.message, 'error', 7000); }
    finally { setGuardando(false); }
  };
  const setCuenta = (i, campo, valor) => setCobro({ ...cobro, cuentas: cobro.cuentas.map((c, j) => (j === i ? { ...c, [campo]: valor } : c)) });

  const sinDatos = cobro && !(cobro.cuentas || []).length && !cobro.paypal_usuario;

  return (
    <>
      <div className="k-card" style={{ padding: '14px', marginBottom: '14px', border: pagos.length ? '2px solid #F59E0B' : undefined }}>
        <b>💸 Pagos por revisar {pagos.length > 0 && <span style={{ background: '#F59E0B', color: '#fff', borderRadius: '999px', padding: '1px 9px', fontSize: '12px', marginLeft: '4px' }}>{pagos.length}</span>}</b>
        {pagos.length === 0 && <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#6B7280' }}>No hay comprobantes pendientes. Cuando una clienta pague por transferencia o PayPal, aparece aquí y te llega un aviso al celular.</p>}
        {pagos.map((x) => {
          const neg = negocios?.[x.negocio_id];
          const ref = x.datos?.ref_banco;
          return (
            <div key={x.id} style={{ padding: '10px 0', borderTop: '1px solid #F3F0FA', fontSize: '13px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ minWidth: 0 }}>
                  <b>{neg?.negocio || 'Negocio'}</b> · {x.correo || neg?.correo || 'sin correo'}
                  <span style={{ display: 'block', color: '#374151' }}>
                    {planPorClave(x.plan)?.nombre} {x.ciclo}{x.datos?.fundador ? ' · 🏅 fundador' : ''} · {x.proveedor === 'paypal' ? '💳 PayPal' : '🏦 Transferencia'}{ref ? ` · ref ${ref}` : ''}
                  </span>
                  <span style={{ display: 'block', color: '#6B7280' }}>Enviado {fecha(x.creado_en)}</span>
                </span>
                <span style={{ textAlign: 'right' }}>
                  <b style={{ fontSize: '16px' }}>{fmtCobro(Number(x.monto), x.moneda)}</b>
                  {x.proveedor === 'paypal' && x.moneda === 'HNL' && <span style={{ display: 'block', color: '#6B7280' }}>≈ US${montoUsd(Number(x.monto), x.moneda).toFixed(2)} en PayPal</span>}
                </span>
              </div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
                <button className="k-btn-soft" style={{ fontSize: '12px', padding: '5px 10px' }} onClick={() => verComprobante(x.comprobante)}>🧾 Ver comprobante</button>
                <button disabled={ocupado === x.id} onClick={() => revisar(x, true)}
                  style={{ fontSize: '12px', padding: '5px 12px', border: 'none', borderRadius: '8px', background: '#047857', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
                  {ocupado === x.id ? 'Guardando…' : '✅ Aprobar y activar'}
                </button>
                <button className="k-btn-soft" style={{ fontSize: '12px', padding: '5px 10px', color: '#B91C1C' }} onClick={() => setRechazando({ id: x.id, motivo: '' })}>Rechazar</button>
              </div>
              {rechazando?.id === x.id && (
                <div style={{ display: 'flex', gap: '6px', marginTop: '8px', flexWrap: 'wrap' }}>
                  <input className="k-input" style={{ flex: 1, minWidth: '180px' }} value={rechazando.motivo} maxLength={200}
                    placeholder="Motivo (lo ve la clienta). Ej: el monto no coincide" onChange={(e) => setRechazando({ ...rechazando, motivo: e.target.value })} />
                  <button disabled={ocupado === x.id} onClick={() => revisar(x, false, rechazando.motivo)}
                    style={{ fontSize: '12px', padding: '5px 12px', border: 'none', borderRadius: '8px', background: '#B91C1C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Confirmar rechazo</button>
                  <button className="k-btn-soft" style={{ fontSize: '12px' }} onClick={() => setRechazando(null)}>No</button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="k-card" style={{ padding: '14px', marginBottom: '14px', border: sinDatos ? '2px dashed #F59E0B' : undefined }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <b>🏦 Datos de cobro (los ven tus clientas al pagar)</b>
          {!editandoCobro && cobro && (
            <button className="k-btn-soft" onClick={() => { setCobro({ ...cobro, cuentas: (cobro.cuentas || []).length ? cobro.cuentas : [{ ...CUENTA_VACIA }] }); setEditandoCobro(true); }}>✏️ Editar</button>
          )}
        </div>
        {!editandoCobro && cobro && (
          sinDatos
            ? <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#92400E' }}>⚠️ Todavía no pones cuentas ni PayPal. Mientras tanto, "Quiero este plan" sigue abriendo WhatsApp.</p>
            : (
              <div style={{ fontSize: '13px', color: '#374151', marginTop: '6px' }}>
                {(cobro.cuentas || []).map((c, i) => <div key={i}>🏦 {c.banco}{c.tipo ? ` · ${c.tipo}` : ''} · <b>{c.numero}</b>{c.titular ? ` · ${c.titular}` : ''}</div>)}
                {cobro.paypal_usuario && <div>💳 paypal.me/<b>{cobro.paypal_usuario}</b></div>}
                {cobro.instrucciones && <div style={{ color: '#6B7280' }}>ℹ️ {cobro.instrucciones}</div>}
              </div>
            )
        )}
        {editandoCobro && (
          <div style={{ display: 'grid', gap: '8px', marginTop: '10px' }}>
            {cobro.cuentas.map((c, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '6px', padding: '8px', border: '1px solid #E9E3F5', borderRadius: '10px' }}>
                <input className="k-input" placeholder="Banco (ej. BAC)" value={c.banco} maxLength={60} onChange={(e) => setCuenta(i, 'banco', e.target.value)} />
                <input className="k-input" placeholder="Tipo (ej. Ahorro)" value={c.tipo} maxLength={40} onChange={(e) => setCuenta(i, 'tipo', e.target.value)} />
                <input className="k-input" placeholder="Número de cuenta" value={c.numero} maxLength={40} onChange={(e) => setCuenta(i, 'numero', e.target.value)} />
                <input className="k-input" placeholder="A nombre de" value={c.titular} maxLength={80} onChange={(e) => setCuenta(i, 'titular', e.target.value)} />
                <button className="k-btn-soft" style={{ fontSize: '12px', color: '#B91C1C' }} onClick={() => setCobro({ ...cobro, cuentas: cobro.cuentas.filter((_, j) => j !== i) })}>Quitar</button>
              </div>
            ))}
            {cobro.cuentas.length < 5 && <button className="k-btn-soft" onClick={() => setCobro({ ...cobro, cuentas: [...cobro.cuentas, { ...CUENTA_VACIA }] })}>+ Agregar cuenta</button>}
            <label style={{ fontSize: '13px', fontWeight: 600 }}>Usuario de PayPal (paypal.me/…)
              <input className="k-input" placeholder="ej. MerlyNunez" value={cobro.paypal_usuario || ''} maxLength={60} onChange={(e) => setCobro({ ...cobro, paypal_usuario: e.target.value })} style={{ marginTop: '4px' }} />
            </label>
            <label style={{ fontSize: '13px', fontWeight: 600 }}>Nota para tus clientas (opcional)
              <input className="k-input" placeholder="ej. Activamos de lunes a sábado, 8 am a 6 pm" value={cobro.instrucciones || ''} maxLength={300} onChange={(e) => setCobro({ ...cobro, instrucciones: e.target.value })} style={{ marginTop: '4px' }} />
            </label>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="k-btn-soft" disabled={guardando} onClick={() => { setEditandoCobro(false); datosCobro().then(setCobro).catch(() => {}); }}>Cancelar</button>
              <button className="k-btn-ghost" disabled={guardando} onClick={guardarCobro}>{guardando ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
